import PropTypes from "prop-types";
import React, { forwardRef } from "react";

import FormButton from "../form/FormButton";

export const OUT_RANGE_BUTTON_DIRECTION = {
  top: "up",
  right: "right",
  bottom: "down",
  left: "left"
};

export const ICON_ON_RIGHT_FOR_DIRECTION = {
  top: false,
  right: true,
  bottom: false,
  left: false
};

const OutOfRangeButton = forwardRef(({ direction, label, onClick, style }, ref) => {
  const icon = `${OUT_RANGE_BUTTON_DIRECTION[direction]}Arrow`;
  const iconOnRight = ICON_ON_RIGHT_FOR_DIRECTION[direction];
  let classNames = ["outOfRangeButton"];
  if (iconOnRight) {
    classNames.push("iconOnRight");
  }
  return (
    <FormButton
      className={classNames.join(" ")}
      onClick={onClick}
      label={label}
      style={style}
      leftIcon={iconOnRight ? null : icon}
      rightIcon={iconOnRight ? icon : null}
      ref={ref}
    />
  );
});

OutOfRangeButton.displayName = "OutOfRangeButton";

OutOfRangeButton.propTypes = {
  direction: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object
};

export default OutOfRangeButton;
